import { ComponentView, DelegatedObservableArrayChangeListenner, ObservableArray, View, ViewGenerator, ViewModel } from "binder"
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean, getAsNumber } from "../utilities";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ComboBoxBaseViewModel } from "./comboBoxBase-viewModel";

export class ComboBoxBaseView extends ComponentView<ComboBoxBaseViewModel>{

    private static activeCombos : {select2Element:any,htmlElement:HTMLElement}[] = [];
    private static isStarted : boolean=false;
    private _direction : string;
    
    GetViewUniqueId(): string {
        return "V-F05C35EC-2E6E-428F-9B7F-2B80F21CB875"
    }
    loadHtml(): string {
        let element = require('./comboBoxBase.html').default;
        let style = require('./comboBoxBase.less');
        return element;
    }
    constructor() {
        super();
        this._direction = (<any>document.body.querySelector('#mainPageDiv')).dir =="rtl" ? "rtl" : "ltr";
        if(ComboBoxBaseView.isStarted==false){
            ComboBoxBaseView.isStarted = true;
            ComboBoxBaseView.startCheckingToDestroy();
        }
    }

    static startCheckingToDestroy(){
        let activeOnes = ComboBoxBaseView.activeCombos.filter(x=>x.htmlElement.isConnected==true);
        let notActiveOnes = ComboBoxBaseView.activeCombos.filter(x=>x.htmlElement.isConnected==false);
        ComboBoxBaseView.activeCombos = activeOnes;

        notActiveOnes.forEach(x=>{
            ComboBoxBaseView.destroy(x.select2Element);
        });
        setTimeout(()=>ComboBoxBaseView.startCheckingToDestroy(),10000);
    }
    static destroy(select2Element){
        select2Element.off('change');
        select2Element.select2('destroy');
    }
    regenerateSelect2(data){
        this._combo.replaceChildren(...[this._option]);
        this._select2Element = this._select2Element.select2(this.generateSelect2Configuration(data));
        this.updateSelection();
    }
    protected generateSelect2Configuration(data):any{
        let result =  <any>{
            width : '100%',
            templateResult : x=>this.templateBodyGenerator(x),
            templateSelection : x=>this.templateHeaderGenerator(x),
            dir:this._direction,
            multiple:this.ismultiple,
            placeholder : this.placeholder,
            closeOnSelect : this.ismultiple ? false : true,
            allowClear : this.allowclear,
        }
        if(this.searchonenter){
            result.SearchOnEnter = this.searchonenter;
        }
        if(data!=null){
            result.data = data;
        }
        if(this.isserverloading && this.loaderfunction!=null){
            result.minimumInputLength = 1;
            result.ajax = {
                url : '',
                data : function(params){
                    return {
                        term : params.term
                    }
                },
                transport : (params,success,failure)=>{
                        this.loaderfunction([],params.data.term)
                            .then(x=>success(x))
                            .catch(x=>failure(x));
                },
                processResults: data => {
                    let result = data.map(x=>{
                        return {
                            id : this.getObjectId(x),
                            value : this.getObjectId(x),
                            text : stringIsNullOrEmpty(this.searchpath) ? '' : x[this.searchpath],
                            viewModelData : x,
                            element : null
                        };
                    });
                    return {
                      results: result
                    };
                }
            }
        }
        return result;
    }

    private _itemsChangeListenner:DelegatedObservableArrayChangeListenner;
    public set items(v: ObservableArray<ViewModel>) { 
        if(this._items){
            this.items.removeChangeListenner(this._itemsChangeListenner);
        }
        this._items = v; 
        if(this._items){
            this._itemsChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.updateItems());
            this._items.addChangeListenner(this._itemsChangeListenner);
        }
        this.updateItems();
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;

    private _selectedItemsChangeListenner:DelegatedObservableArrayChangeListenner;
    public set selectedItemsList(v: ObservableArray<ViewModel>) { 
        if(this._selectedItemsList){
            this.selectedItemsList.removeChangeListenner(this._selectedItemsChangeListenner);
        }
        this._selectedItemsList = v; 
        if(this._selectedItemsList){
            this._selectedItemsChangeListenner = new DelegatedObservableArrayChangeListenner(this,()=>this.updateSelection());
            this._selectedItemsList.addChangeListenner(this._selectedItemsChangeListenner);
        }
        this.updateSelection();
    
    } public get selectedItemsList(): ObservableArray<ViewModel> { return this._selectedItemsList;} private _selectedItemsList: ObservableArray<ViewModel>;
    public set itemtemplateselector(v: ITemplateSelector) { 
        this._itemtemplateselector = v; 
        if(this._select2Element) {
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { 
        this._templateselectorfunction = v; 
        if(this._select2Element) {
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    public set importanthasselectorfunction(v: boolean) { 
        this._importanthasselectorfunction = getAsBoolean(v); 
        if(this._select2Element) {
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;
    public set searchpath(v: string) { 
        this._searchpath = v; 
        if(this._select2Element) {
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get searchpath(): string { return this._searchpath;} private _searchpath: string;
    public set idsearchpath(v: string) { 
        this._idsearchpath = v; 
        if(this._select2Element) {
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get idsearchpath(): string { return this._idsearchpath;} private _idsearchpath: string;
    
    public set tabindex(v: number) { this._tabindex = getAsNumber(v,true); } public get tabindex(): number { return this._tabindex; getAsNumber} private _tabindex: number;
    public set placeholder(v: string) { 
        this._placeholder = v; 
        if(this._select2Element && stringIsNullOrEmpty(v)==false){
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get placeholder(): string { return this._placeholder;} private _placeholder: string;
    public set ismultiple(v: boolean) { 
        this._ismultiple = getAsBoolean(v);
        if(this._select2Element){
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get ismultiple(): boolean { return this._ismultiple;} private _ismultiple: boolean;
    public set allowclear(v: boolean) { 
        this._allowclear = getAsBoolean(v);
        if(this._select2Element){
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get allowclear(): boolean { return this._allowclear;} private _allowclear: boolean;
    public set searchonenter(v: boolean) { 
        this._searchonenter = getAsBoolean(v); 
        if(this._select2Element){
            this.regenerateSelect2(this.getCurrentData(false));
        }
    
    } public get searchonenter(): boolean { return this._searchonenter;} private _searchonenter: boolean;
    public set isserverloading(v: boolean) { 
        this._isserverloading = getAsBoolean(v); 
        if(this._select2Element){
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get isserverloading(): boolean { return this._isserverloading;} private _isserverloading: boolean;
    public set loaderfunction(v: (ids:string[],searchText:string)=>Promise<ViewModel>) { 
        this._loaderfunction = v; 
        if(this._select2Element){
            this.regenerateSelect2(this.getCurrentData(false));
        }
    } public get loaderfunction(): (ids:string[],searchText:string)=>Promise<ViewModel> { return this._loaderfunction;} private _loaderfunction: (ids:string[],searchText:string)=>Promise<ViewModel>;
    
    private itemTemplate : Node;
    private headerTemplate : Node;

    templateHeaderGenerator(x: any) {
        if(x.viewModelData instanceof ViewModel){
            let newNode = ViewGenerator.GetNodeByTemplate(x.viewModelData,this.headerTemplate ?? this.itemTemplate)
            return $(newNode);
        }else{
            return x.text;
        }
    }
    templateBodyGenerator(x: any) {
        if(x.viewModelData instanceof ViewModel){
            let template : any;
            let newNode : Element;
            let vm = x.viewModelData;
            if(this.itemtemplateselector && this.itemtemplateselector.getTemplate){
                template = this.itemtemplateselector.getTemplate(vm,this.templateselectorfunction);
                if(template){
                    newNode = ViewGenerator.CreateFromPrototypeAndViewModel(template,vm);
                }
            }
            if(newNode==null){
                template = this.itemTemplate;
                newNode = ViewGenerator.GetNodeByTemplate(vm,template);
            }
            return $(newNode);
        }else{
            return x.text;
        }
    }

    private isTriggering : boolean=false;
    private getObjectId(vm:ViewModel):string{
        let id = ''
        if(stringIsNullOrEmpty(this.idsearchpath)==false){
            id = vm[this.idsearchpath];
        }
        if(stringIsNullOrEmpty(id)){
            id = vm.viewModelObjectId.toString();
        }
        return id;
    }
    private updateItems(){
        if(this._select2Element){
            let data = [];
            if(this.items!=null){
                data = this.items.map(x=>{
                    return {
                        id : this.getObjectId(x),
                        value : this.getObjectId(x),
                        text : stringIsNullOrEmpty(this.searchpath) ? '' : x[this.searchpath],
                        viewModelData : x,
                        element : null
                    };
                });
            }
            this.regenerateSelect2(data);
        }
    }
    private updateSelection(){
        if(this._select2Element){
            if(this.isTriggering==false){
                this.isTriggering = true;
                if(this.isserverloading){
                    this.selectedItemsList.forEach(x=>{
                        if(this._select2Element.find(`option[value='${this.getObjectId(x)}']`).length){

                        }else{
                            let text = stringIsNullOrEmpty(this.searchpath) ? '' : x[this.searchpath];
                            let id = this.getObjectId(x);
                            let newOption = new Option(text,id);

                            // id : this.getObjectId(x),
                            // value : this.getObjectId(x),
                            // text : stringIsNullOrEmpty(this.searchpath) ? '' : x[this.searchpath],
                            // viewModelData : x,
                            // element : null
                            (<any>newOption).viewModelData = x;
                            this._select2Element.append(newOption);
                        }
                    })
                }
                let selectedIds = this.selectedItemsList.filter(x=>x!=null).map(x=>this.getObjectId(x));
                this._select2Element.val(selectedIds);
                this._select2Element.trigger('change');
                this.isTriggering = false;
            }
        }
    }
    getCurrentData(allowReturnNull:boolean){
        let data = [];
        if(this.items!=null){
            data = this.items.map(x=>{
                return {
                    id : this.getObjectId(x),
                    value : this.getObjectId(x),
                    text : stringIsNullOrEmpty(this.searchpath) ? '' : x[this.searchpath],
                    viewModelData : x,
                    element : null
                };
            })
            return data;
        }else{
            if(allowReturnNull){
                return null;
            }else{
                return [];
            }
        }
    }
    updateSelectionAndItems(){
        this.updateItems();
        this.updateSelection();
        
    }
    private _select2Element : any;
    private _combo : HTMLSelectElement;
    private _option : HTMLOptionElement;
    public onRenderCompleted() {
        this._combo = <HTMLSelectElement>this.firstlevelElement.querySelector('select');
        this._option = <HTMLOptionElement>this.firstlevelElement.querySelector('#optionId')
        this._select2Element = (<any>$(this._combo));
        this._select2Element.select2(this.generateSelect2Configuration(this.getCurrentData(true)));
        let handler = e=>this.onChange(e);
        this._select2Element.on('change',handler);
        ComboBoxBaseView.activeCombos.push({
            htmlElement : this._combo,
            select2Element : this._select2Element
        });
        this.updateSelectionAndItems();
    
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("header-template")){
                this.headerTemplate = super.removeAsTemplate(node);
            }else if(node instanceof HTMLElement && node.classList.contains("template")){
                this.itemTemplate = super.removeAsTemplate(node);
            }else if(node instanceof HTMLOptionElement){
                this._combo.append(node);
            }
        })
    }
    private onChange(e){
        if(this._select2Element){
            let selectedItems = this._select2Element.select2('data');
            if(this.selectedItemsList){
                this.selectedItemsList.update(...selectedItems.map(x=>x.viewModelData ??x.element.viewModelData));
            }
        }
    }
}
